import {mapValues} from 'lodash'
import React, {useContext} from 'react'
import {useLocation} from 'react-router-dom'
import {useTheme, makeStyles} from 'external/material'
import Grid from '@mui/material/Grid'

import AssessmentStandardsDialog from './components/assessment-standards/dialog'
import StandardsSearch from 'teacher/components/standards-search'
import {TeacherContext} from 'teacher/context'

import Tabs from './tabs'
import Footer from './footer'
import Content from './content'

const useStyles = makeStyles(quizStyles)

export default function Quiz () {

  const classes = useStyles()
  const location = useLocation()
  const context = useContext(TeacherContext)

  const {preferences, link, tab, sectionName, updateState} = context
  const {properties, loaded} = preferences

  function handleSearchStandards(filters) {
    return updateState({
      quizStandardFiltersCalls: {$apply: i => i + 1},
      quizStandardFilters: mapValues(filters, v => ({$set: v}))
    })
  }

  return (
    <Grid container direction="column" className={classes.root} wrap="nowrap">
      <Grid item className={classes.header}>
        <Tabs context={context} />
        <AssessmentStandardsDialog closePath={context.link({}, '/:languageId/:role/:page/:tab', {preserveQuery: true})} />
        <StandardsSearch open={sectionName == 'standards-search'} closePath={context.link({}, '/:languageId/:role/:page/:tab', {preserveQuery: true})} onSearchStandards={handleSearchStandards} />
      </Grid>
      <Grid item className={classes.content}>
        <Content context={context} />
      </Grid>
      <Grid item className={classes.footer}>
        <Footer context={context} />
      </Grid>
    </Grid>
  )
}

function quizStyles(theme) {
  return {
    root: {
      flexGrow: 1,
    },
    content: {
      display: 'flex',
      flexGrow: 1,
      overflow: 'auto'
    },
    footer : {
      backgroundColor: '#fff',
      padding: 15,
      border: 'solid 1px #e0e0e0',
      borderBottomLeftRadius: 2,
      borderBottomRightRadius: 2
    }
  }
}
